var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSuccessPayment = function SvgSuccessPayment(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2811",
    "data-name": "Group 2811",
    width: 60.185,
    height: 60.287,
    viewBox: "0 0 60.185 60.287",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2666",
    "data-name": "Rectangle 2666",
    width: 60.185,
    height: 60.286,
    fill: "#4caf50"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2809",
    "data-name": "Group 2809",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26585",
    "data-name": "Path 26585",
    d: "M32.317,0c1.041.155,2.09.27,3.122.473A29.636,29.636,0,0,1,56.413,15.554a29.642,29.642,0,0,1,3.728,16.393A12.879,12.879,0,0,1,59.96,33.7a2.93,2.93,0,0,1-5.8-.789,24.878,24.878,0,0,0-.195-6.683A23.824,23.824,0,0,0,42.775,9.53,23.252,23.252,0,0,0,29.79,5.937,24,24,0,0,0,6.436,25.214c-1.856,9.473,1.033,17.5,8.428,23.761a22.833,22.833,0,0,0,12.4,5.265,23.9,23.9,0,0,0,15.506-3.434,3.18,3.18,0,0,1,2.441-.571,2.947,2.947,0,0,1,.978,5.4,29.5,29.5,0,0,1-10.057,4.048c-1.26.252-2.54.407-3.811.606H27.852c-.674-.09-1.35-.169-2.023-.271A30.206,30.206,0,0,1,.476,35.448C.275,34.394.157,33.325,0,32.263V27.906c.038-.17.083-.339.114-.511A44.212,44.212,0,0,1,1.1,22.1C4.789,10.259,12.673,2.979,24.85.472,25.879.261,26.929.155,27.969,0Z",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26586",
    "data-name": "Path 26586",
    d: "M108.052,136.534a6.223,6.223,0,0,1,.5-.679q6.746-6.77,13.5-13.529a2.952,2.952,0,0,1,4.458,3.871c-.138.165-.293.316-.445.469q-7.827,7.851-15.657,15.7c-1.6,1.6-3.206,1.6-4.8.008-2.341-2.345-4.694-4.677-7.016-7.04a2.943,2.943,0,0,1,1.341-4.951,2.88,2.88,0,0,1,2.9.83q2.327,2.331,4.652,4.663c.151.152.281.326.563.657",
    transform: "translate(-82.375 -102.299)",
    fill: "#4caf50"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success-payment.b77b1ade.svg";
export { ForwardRef as ReactComponent };